<template>
  <div>
    <Card v-show="!isComponent">
      <p slot="title">退保证金</p>
      <Row type="flex" align="middle" style="width:500px;margin:0 auto;">
        <Col style="width:130px;margin:0 14px;">
          <menuIcon imageUrl="/img/icons/ticheng/1.png" title="退保申请" @click.native="showDetail('depositBackApply')"></menuIcon>
        </Col>
        <Col style="margin: 0 14px">
          <Icon type="chevron-right" size="20"></Icon>
          <Icon type="chevron-right" size="20"></Icon>
          <Icon type="chevron-right" size="20"></Icon>
        </Col>
        <Col style="width:130px;margin:0 14px;">
          <menuIcon :count="flowCount" imageUrl="/img/icons/ticheng/3.png" title="流程审批" @click.native="showDetail('depositApplyFlow')"></menuIcon>
        </Col>
      </Row>
    </Card>
    <component 
      :is="componentName"
      v-show="isComponent"
      @return="(val)=>{isComponent=val}" @num="(num) => {flowCount=num}"></component>
  </div>
</template>

<script>
import MenuIcon from '@/components/menuIcon'
import DepositBackApply from './depositBackApply'
import DepositApplyFlow from './depositApplyFlow'

export default {
  name: 'depositBackMenu',
  components: {
    MenuIcon,
    DepositBackApply,
    DepositApplyFlow
  },
  data() {
    return {
      flowCount: 0,
      isComponent: false,
      componentName: 'depositApplyFlow',
    }
  },
  methods: {
    showDetail(type = '') {
      if (type === '') {
        return
      }
      this.isComponent = true
      this.componentName = type
    }
  }
}
</script>
